import { render, staticRenderFns } from "./otaInventory.vue?vue&type=template&id=6c125b2f"
import script from "./otaInventory.vue?vue&type=script&lang=js"
export * from "./otaInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports